export const createSingleLineErrorFn = message => res => ({ type: 'singleLine', message: res.data.error || message });
